export default `
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./app/styles/overflowEllipsis.jsx